import { createActionTypes } from 'utils/action/actionTypes';

export const GET_DASHBOARD_DATA = createActionTypes('GET_DASHBOARD_DATA');
